export default "__VITE_ASSET__DVZrWLGU__"